import type { Address } from "viem"
import type { Config } from "wagmi"

import type { TransactionReturnType } from "@/domains/on-chain/types"
import { reset } from "@/domains/on-chain"

import type { IResetNftActions } from "./interfaces"

/**
 * Adapter that implements IResetNftActions using the actual on-chain functions.
 * This is the production implementation injected into the interaction.
 */
export class ResetNftActionsAdapter implements IResetNftActions {
  async reset(params: {
    account: Address
    chainId: number
    config: Config
    voterAddress: Address
    tokenId: number
  }): Promise<TransactionReturnType> {
    return await reset(params)
  }
}
